var module = angular.module('octopusApp.infrastructure');

module.directive('inOrOut', function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      options: "=",
      selectedItems: "="
    },
    template: '<div class="in-or-out row margin-top-bottom-20">\n' +
    '    <div class="in-or-out-list col-md-12">\n' +
    '        <label for="excluded-list">Excluded</label>\n' +
    '        <select id="excluded-list" multiple="multiple" ng-dblclick="include()" class="form-control list-excluded" ng-model="excludeSelection" ng-options="item.label group by item.group for item in excludeList | orderBy:[\'sort\',\'group\']"></select>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '        <div class="in-or-out-buttons"><button type="button" class="btn btn-default" ng-click="include()">Include <span class="glyphicon glyphicon-arrow-down" aria-hidden="true"></span></button></div>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '        <div class="in-or-out-buttons"><button type="button" class="btn btn-default" ng-click="exclude()">Exclude <span class="glyphicon glyphicon-arrow-up" aria-hidden="true"></span></button></div>\n' +
    '    </div>\n' +
    '    <div class="in-or-out-list col-md-12">\n' +
    '        <label for="included-list">Included</label>\n' +
    '        <select id="included-list" multiple="multiple" ng-dblclick="exclude()" class="form-control list-included" ng-model="includeSelection" ng-options="item.label group by item.group for item in includeList | orderBy:[\'sort\',\'group\']"></select>\n' +
    '    </div>\n' +
    '</div>',
    link: function (scope, element) {
      scope.excludeList = [];
      scope.includeList = [];

      scope.excludeSelection = [];
      scope.includeSelection = [];

      // options will be a list of JSON objects with the following properties:
      //   { Id: 'foo', Sort: 'Foo', Group: 'bar', Name: 'Foo' }
      scope.$watch("options", function() {
        scope.reload();
      });
      scope.$watch("selectedItems", function() {
        scope.reload();
      });

      scope.include = function () {
        _.each(scope.excludeSelection, function (item) {
          scope.selectedItems.push(item.value);
        });

        scope.reload();
      };

      scope.exclude = function () {
        _.each(scope.includeSelection, function (item) {
          var itemIndex = scope.selectedItems.indexOf(item.value);
          if (itemIndex >= 0) {
            scope.selectedItems.splice(itemIndex, 1);
          }
        });

        scope.reload();
      };

      var renderItemsInList = function(boundList, items) {

        _.each(items, function (item) {
          boundList.push({ group: item.Group, value: item.Id, label: item.Name, sort: item.Sort });
        });

      };
      
      scope.reload = function () {
        scope.includeList.length = 0;
        scope.excludeList.length = 0;

        if (!scope.options) {
          return;
        }

        var selectedItemsDictionary = {};
        _.each(scope.selectedItems, function(i) {
          selectedItemsDictionary[i] = "true";
        });

        var excludedItems = _.filter(scope.options, function(item) { return !selectedItemsDictionary[item.Id];});
        var includedItems = _.filter(scope.options, function(item) { return selectedItemsDictionary[item.Id] === "true"; });

        renderItemsInList(scope.excludeList, excludedItems);
        renderItemsInList(scope.includeList, includedItems);
      };

      scope.reload();
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/in_or_out.js
// module id = 6032463219269661
// module chunks = 1